import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import { BASE_IMG_URL } from '@images/imageUrls';
import { withRouter } from 'react-router-dom';
import { formatNumberToWan } from '@utils/formatNumber'
interface PCSidebarCherryPickListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    indexRecommendThread?: any
    threadClick?: any
    goHome?: any
}


@inject('app', 'site', 'user')
@observer
class PCSidebarCherryPickList extends React.Component<PCSidebarCherryPickListProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }

    render() {
        const { site, app, indexRecommendThread, threadClick, goHome } = this.props;
        
        return <>
            <div className={styles.topicListBox}>
                 <div className={styles.titleBox}>
                    <h1 className={styles.title}>社区精选</h1>
                    <div className={styles.titleMore} onClick={()=> goHome && goHome()}>更多</div>
                 </div>
                 <div className={styles.indexRecommendThreadList}>
                    {indexRecommendThread?.map((item: any, index: any) => (
                        <div key={item?.id ?? `topic-${index}`} className={styles.topicItem} onClick={() => threadClick && threadClick(item)}>
                            <div className={styles.topicIndex}>{index + 1}</div>
                            <div className={styles.topicContent}>{item.title || item.summary}</div>
                        </div>
                    ))}
                 </div>
            </div>
        </>;

    }
}

export default PCSidebarCherryPickList;